import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=187b3942&scoped=true"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"
import style0 from "./TableInput.vue?vue&type=style&index=0&id=187b3942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b3942",
  null
  
)

export default component.exports